import React from "react";
import { useAppState } from "../RetailerFitGuide_StateContext.jsx";
import { RetailerFitGuide_ClearCar } from "../Shared/RetailerFitGuide_ClearCar.jsx";
import { RetailerFitGuide_RefitResultItem } from "./RetailerFitGuide_RefitResultItem.jsx";
import { isValidSolutionType } from "../Script/RetailerFitGuide_Utils.js";

const RetailerFitGuide_RefitResult = ({ reset, openOldCar, openNewCar }) => {
    const {
        selectedSolution,
        oldCarResult,
        newCarResult,
        translations,
    } = useAppState();

    if (!selectedSolution || !oldCarResult || !newCarResult)
        return null;

    const filteredSolutions = newCarResult.solutions?.filter(x => isValidSolutionType(x.solutionType) && x.statusErp === "Sellable")?.sort((a, b) => a.dataProductDisplayPriority - b.dataProductDisplayPriority);

    return <div className="retailerFitGuide_RefitResult">
        <button onClick={openOldCar} className="refitResult_car btn">
            <div className="paragraph--s text-color--gray80">{translations.oldCar}</div>
            <div className="heading6">
                {oldCarResult.year} {oldCarResult.make} {oldCarResult.model} {oldCarResult.carVariation}</div>
            <div className="heading6">{selectedSolution.dataProductWebtitle1}</div>
        </button>
        <div className="d-flex justify-content-center my-3"><i className="le-icon-arrow rot-270"></i></div>
        <button onClick={openNewCar} className="refitResult_car mb-4 btn">
            <div className="paragraph--s text-color--gray80">{translations.newCar}</div>
            <div className="heading6">
                {newCarResult.year} {newCarResult.make} {newCarResult.model} {newCarResult.carVariation}</div>
        </button>

        <RetailerFitGuide_ClearCar clearEvent={reset} />

        <div className="refitResult_systems">
            <p className="heading4">{translations.availableSystems}</p>
            {filteredSolutions?.length > 0 ? filteredSolutions.map((solution, index) => <div key={index}>
                <RetailerFitGuide_RefitResultItem solution={solution} />
            </div>) : <p className="paragraph mt-7">{translations.noAvailableSystems}.</p>}
            { }
        </div>
    </div>
}

export default RetailerFitGuide_RefitResult;